module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "title": "Title Page"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Pocket Dictionary of"), _c('br'), _vm._v("\n  Apologetics &"), _c('br'), _vm._v("\n  Philosophy of Religion")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("C. Stephen Evans")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "IVP Books Imprint",
      "src": "Images/IVP_Academic_Third.jpg"
    }
  })]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.IVPress.com/academic/",
      "target": "_blank"
    }
  }, [_vm._v("www.IVPress.com/academic")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55af9e88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/title.vue
// module id = 57
// module chunks = 0